module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Value":"Wert","Key":"Eindeutige Kennung","Identifies this option in imports and keeps the articles attached to it. It stays put when the value is renamed.":"Identifiziert diese Option in Importen und hält die daran hängenden Artikel fest. Beim Umbenennen des Werts bleibt er unverändert.","Image":"Bild","Addition":"Zusatz","Description":"Beschreibung","Group":"Gruppierung"}}')
  delete Component.options._Ctor
}
